import { createContext } from "react";
export const AuthContext = createContext(null);
//# sourceMappingURL=context.js.map